import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button } from '@material-ui/core';
import instance from '../../../request/http';
import { BASE_URL } from '../../../store/config';
import { clone, deduplicationObjArr, deduplicationObjArr2, getObjByName } from '../../../common/utils';
import UserTable from './UserTable';

const Root = styled(Box)({
    width: '100%',
    '& .textField': {
        backgroundColor: '#fff',
        width: '159px',
        margin: '0 0 0 10px',
    },
    '& .table': {
        width: '100%',
        borderCollapse: 'collapse',
        border: '1px solid #EDEDED',
        '& th': {
            height: '35px',
            backgroundColor: '#EDEDED',
            border: '1px solid #EDEDED'
        },
        '& td': {
            height: '35px',
            border: '1px solid #EDEDED'
        },
        '& .noBorder': {
            border: 'none',
        },
        '& .addBtn': {
            verticalAlign: 'top',
        },
        '& .bgTransparent': {
            backgroundColor: 'transparent',
        },
        '& .mr-10': {
            marginRight: '10px',
        },
    },
})
class AttorneyRateList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeArr: [
                "legal fee",
                "filing fee",
                "Registered Agent Annual Fee",
                "Printing & Mailing Fee",
                "Third Party Fee"
            ],
            temp_item: "",
            name: "",
            rateListArr: [],
            legalData: [],
            rateData: [],
            serviceData: [],
            arrIndex: 0,
            openTable: false,
            rateUserId: "",
            editRate: 0,
        }
        this.handleSave = this.handleSave.bind(this);
        this.handleRateChange = this.handleRateChange.bind(this);
        this.handleServiceChange = this.handleServiceChange.bind(this);
        this.handleCheckBox = this.handleCheckBox.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleCloseTable = this.handleCloseTable.bind(this);
    }
    render() {
        const {
            rateData,
            legalDataCopy,
            openTable,
            rateUserId,
            editRate,
        } = this.state;
        return (
            <Root>
                <table className="table" cellPadding={10}>
                    <thead>
                        <tr>
                            <th width="40%" align="center" className="noBorder">Name</th>
                            <th width="30%" align="center" className="noBorder">Rate</th>
                            <th width="30%" align="center" className="noBorder">Operation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rateData.map((row, index) => (
                            <tr key={index}>
                                <td align="center">{row.handler.first_name + " " + row.handler.last_name}</td>
                                <td align="center">
                                    <div className="h h-c">
                                        <span>$</span>
                                        <TextField
                                            className="textField"
                                            value={row.rate}
                                            onChange={e => this.handleRateChange(e, index)}
                                            margin="dense"
                                            variant="outlined"
                                            inputProps={{
                                                style: {
                                                    height: '5px',
                                                    padding: '14px',
                                                },
                                            }}
                                        />
                                    </div>
                                </td>
                                <td align="center">
                                    <Button size="small" className="btn mr-10" variant="outlined" color="primary" onClick={e => this.handleSave(e, row)}>SAVE</Button>
                                    {/* <Button size="small" className="btn" variant="outlined" color="secondary" onClick={e => this.handleDel(e, row)}>Delete</Button> */}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <UserTable
                    open={openTable}
                    rateUserId={rateUserId}
                    legalData={legalDataCopy}
                    rate={editRate}
                    onClose={this.handleCloseTable}
                ></UserTable>
            </Root>
        )
    }
    componentDidMount() {
        this.initEditor();
    }
    componentDidUpdate(prevProps) {
        const {
            legalData,
        } = this.props;
        if (prevProps.legalData !== legalData) {
            this.initEditor();
        }
    }
    initEditor() {
        const legalData = clone(this.props.legalData);
        const legalDataCopy = clone(this.props.legalData);
        if (!legalData) return;
        if (legalData.length <= 0) return;
        this.loopCheckRate(() => {
            const { rateListArr } = this.state;
            let rateData = [];
            for (const legalObj of legalData) {
                for (const rateObj of rateListArr) {
                    if (legalObj.handler.id === rateObj.user_id && legalObj.rate === rateObj.rate) {
                        rateData.push(legalObj);
                    }
                }
            }
            const newData = deduplicationObjArr2(rateData, "handler", "id");
            this.setState(() => ({
                legalData,
                legalDataCopy,
                rateData: newData
            }))
        });
    }

    loopAddRate(callback) {
        let { arrIndex } = this.state;
        const { invoiceId, legalData } = this.props;
        let obj = legalData[arrIndex];
        this.addInvoiceRate(invoiceId, obj.handler.id, obj.rate, () => {
            arrIndex++;
            this.setState({
                arrIndex
            }, () => {
                if (arrIndex === legalData.length) {
                    this.setState({
                        arrIndex: 0
                    }, () => {
                        if (callback) callback();
                    })
                } else {
                    this.loopAddRate(callback);
                }
            });
        });
    }
    loopCheckRate(callback) {
        let { arrIndex } = this.state;
        const { invoiceId, legalData } = this.props;
        let obj = legalData[arrIndex];
        const userId = obj.handler.id;
        const rate = obj.rate ? obj.rate : obj.handler.rate;
        this.getInvoiceRate(invoiceId, userId, rate, () => {
            arrIndex++;
            this.setState({
                arrIndex
            }, () => {
                // if (!hasRate) {
                //     this.addInvoiceRate(invoiceId, userId, rate);
                // }
                if (arrIndex === legalData.length) {
                    this.setState({
                        arrIndex: 0
                    }, () => {
                        if (callback) callback();
                    })
                } else {
                    this.loopCheckRate(callback);
                }
            });
        });
    }
    getTimesheets() {
        const { matterId } = this.props;
        this.getTimesheet(matterId);
    }
    handleSave(e, row) {
        const userId = row.handler.id;
        const rate = row.rate;
        this.setState({
            openTable: true,
            rateUserId: userId,
            editRate: rate,
        })
    }
    updateInvoiceRate(userId, rate, callback) {
        const { rateListArr } = this.state;
        const rateObj = getObjByName(rateListArr, "user_id", userId)
        this.putInvoiceRate(rateObj.id, rate, () => {
            if (callback) callback();
        });
    }
    handleSelect(e, index) {
        const value = e.target.value;
        let [...serviceData] = this.state.serviceData;
        const obj = serviceData[index];
        obj.serviceItem = value;
        this.setState(() => ({
            serviceData,
        }))
    }
    handleEdit(e, name) {
    }
    handleRateChange(e, index) {
        const { rateData } = this.state;
        const value = e.target.value;
        let obj = rateData[index];
        obj.rate = value;
        this.setState({
            rateData
        }, () => {
            // this.setRateToService();
        })
    }
    handleServiceChange(e, index) {
        const { serviceData } = this.state;
        const value = e.target.value;
        let obj = serviceData[index];
        obj.serviceItem = value;
        this.setState(() => ({
            serviceData
        }))
    }
    handleCheckBox(e, index) {
        const { serviceData } = this.state;
        let obj = serviceData[index];
        obj.check = !obj.check;
        this.setState({
            serviceData
        }, () => {
            this.setAttorneys();
        })
    }
    handleCloseTable(changeRateArr, rate) {
        this.setState(() => ({
            openTable: false
        }))
        if (changeRateArr) {
            this.updateInvoiceRate(this.state.rateUserId, Number(rate), () => {
                this.setState({
                    rateListArr: []
                })
                this.props.handleSave(changeRateArr, Number(rate));
            });
        }
    }
    changeType(str) {
        if (str === "legal_fee") return "legal fee";
        return str;
    }
    changeHToS(h) {
        return parseFloat(h * 3600);
    }
    changeSToH(s, plusNum = 0) {
        let totalS = parseFloat(s) + parseFloat(plusNum);
        if (totalS) {
            return Math.floor(((totalS + 35) / 3600) * 100) / 100;
        } else {
            return 0;
        }
    }
    setAttorneys() {
        const { serviceData } = this.state;
        let tempRateData = [];
        for (const obj of serviceData) {
            if (obj.check) {
                tempRateData.push(obj)
            }
        }
        // const rateData = deduplicationObjArr2(tempRateData, "handler", "id");
        this.setState(() => ({
            tempRateData
        }));
    }
    setRateToService() {
        const { serviceData, rateData } = this.state;
        let [...tempServiceData] = serviceData;
        let [...tempRateData] = rateData;

        for (const rateObj of tempRateData) {
            for (const servObj of tempServiceData) {
                if (servObj.handler.id === rateObj.handler.id) {
                    servObj.handler.rate = rateObj.handler.rate;
                }
            }
        }
        this.setState(() => ({
            serviceData: tempServiceData
        }));
    }
    getArrIndex(objArr, key, key2, name) {
        return objArr.findIndex((element) => (element[key][key2] === name));
    }
    handlerName(obj) {
        if (!obj) return "";
        const firstName = obj.first_name ? obj.first_name : "";
        const lastName = obj.last_name ? obj.last_name : "";
        return firstName + " " + lastName;
    }
    //----------------request-------------------------------
    getTimesheet(matter_id) {
        const params = {
            matter_id
        }
        instance.get(BASE_URL + 'billing/legal_fee', { params }).then((res) => {
            const timesheetData = res.data.data;
            let serviceData = [];
            for (const obj of timesheetData) {
                obj.check = false;
                serviceData.push(obj);
            }
            this.setState(() => ({
                serviceData
            }))
        })
    }
    getInvoiceRate(invoice_id, user_id, rate = null, callback) {
        instance.get(BASE_URL + `billing/invoices/${invoice_id}/users/${user_id}/rate`).then((res) => {
            const rateArr = res.data.data;
            const mergeRateArr = this.state.rateListArr.concat(rateArr);
            const rateListArr = deduplicationObjArr(mergeRateArr, "id");
            this.setState({
                rateListArr
            }, () => {
                if (rateArr.length <= 0) {
                    this.addInvoiceRate(invoice_id, user_id, rate, () => {
                        this.getInvoiceRate(invoice_id, user_id, rate, callback);
                    });
                } else {
                    if (callback) callback();
                }
            })
        })
    }
    putInvoiceRate(rate_id, rate, callback) {
        const params = {
            rate
        }
        instance.put(BASE_URL + `billing/invoices/users/rate/${rate_id}`, params).then((res) => {
            setTimeout(() => {
                if (callback) callback();
            }, 1000);
        })
    }
    addInvoiceRate(invoice_id, user_id, rate, callback) {
        const params = {
            rate
        }
        instance.post(BASE_URL + `billing/invoices/${invoice_id}/users/${user_id}/rate`, params).then((res) => {
            if (callback) callback();
        })
    }
    delInvoiceRate(rate_id, callback) {
        instance.delete(BASE_URL + `billing/invoices/users/rate/${rate_id}`).then((res) => {
            if (callback) callback();
        })
    }
}

export default AttorneyRateList;